import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const OrgRkoActionsCell = (props: {
  isBilling: boolean;
  name: string;
  onSetBilling: () => void;
  onUnlink: () => void;
}) => {
  const [isUnlinkOpen, toggleUnlinkOpen] = useToggle();
  const [isSetBillingOpen, toggleSetBillingOpen] = useToggle();

  const onConfirmSetBilling = () => {
    toggleSetBillingOpen();
    props.onSetBilling();
  };

  const onConfirmUnlink = () => {
    toggleUnlinkOpen();
    props.onUnlink();
  };

  return (
    <>
      <ActionMenu
        actions={[
          !props.isBilling && {
            content: 'Set as billing record keeper',
            onSelect: toggleSetBillingOpen
          },
          { content: 'Unlink', onSelect: toggleUnlinkOpen }
        ]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.name)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmText='Set Billing Record Keeper'
        data-testid={camelCase(`set billing ${props.name}`)}
        isOpen={isSetBillingOpen}
        message={`Bill this advisory organization through ${props.name}? ACT Analytics licensing is inherited from the billing record keeper, so this changes which licenses the organization sees.`}
        onCancel={toggleSetBillingOpen}
        onConfirm={onConfirmSetBilling}
        title='Set Billing Record Keeper'
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Unlink'
        data-testid={camelCase(`unlink ${props.name}`)}
        isOpen={isUnlinkOpen}
        message={
          props.isBilling
            ? `${props.name} is the billing record keeper for this advisory organization. Unlinking it leaves the organization without one and disables ACT Analytics. Continue?`
            : `Unlink ${props.name} from this advisory organization?`
        }
        onCancel={toggleUnlinkOpen}
        onConfirm={onConfirmUnlink}
        title='Unlink Record Keeping Organization'
      />
    </>
  );
};
